@if (
  navigationService?.config?.icons &&
  navigationService?.config?.icons?.tablet &&
  navigationService?.config?.icons?.tablet?.length > 0
) {
  <header class="tablet-toolbar" data-test-id="tabletToolbarHeader">
    <div class="container">
      <div class="u-flex u-alignCenter u-justifyBetween">
        <div class="tablet-toolbar__contact">
          <p class="t-data" data-test-id="tabletToolbarContactMsg">
            Contact Support
          </p>
        </div>
        <section class="nav__icons">
          @for (
            tool of navigationService.config.icons.tablet;
            track tool;
            let i = $index
          ) {
            <a
              class="nav__link"
              [ngClass]="{
                'is-active': navigationService.isActiveRoute(tool.route),
              }"
              [routerLink]="tool.route"
              data-test-id="tabletToolbarNavLink"
              (click)="navigationService.selectNavLink($event, tool)"
            >
              <i
                class="icon icon--medium"
                [data-test-id]="'tabletToolbarIcon_' + i"
                >{{ tool.icon }}</i
              >
            </a>
          }
        </section>
      </div>
    </div>
  </header>
}
